import { useQuery } from '@tanstack/react-query'
import { useApi } from '../store/auth.store'

export interface CompanyData {
  id: string
  name: string
  nit: string
  businessName: string | null
  logoUrl: string | null
  mainContact: string | null
  mainEmail: string | null
  phone: string | null
}

export function useCompany() {
  const api = useApi()
  return useQuery<CompanyData>({
    queryKey: ['company'],
    queryFn: () => api.get<CompanyData>('/companies/me'),
  })
}